module.exports = __webpack_public_path__ + "static/media/Teko-Regular.b35fa5f3.ttf";